import { mapActions } from 'vuex';
import contentHeader from '@/components/generics/content-header/content-header.vue';
import catchHtmlClickMixin from '@/helpers/catchHtmlClickMixin';
import faq from '@/components/support/faq/faq.vue';
import { MODALS } from '@/components/app/app-modals/app-modals';
import supportMixin from '@/mixins/support';
import cmsContentMixin from '@/mixins/cmsContent';
import { STATIC_PAGES } from '@/constants';

const DEFAULT_TITLE = 'What is PredictIt?';

export default {
  mixins: [
    cmsContentMixin,
    catchHtmlClickMixin,
    supportMixin,
  ],
  props: {
    title: {
      type: String,
      default: DEFAULT_TITLE,
    },
  },
  components: {
    contentHeader,
    faq,
  },
  metaInfo() {
    return {
      title: 'Support',
    };
  },
  data() {
    return {
      topBasics: [
        {
          name: DEFAULT_TITLE,
          text: '',
        },
      ],
    };
  },
  computed: {
    topics() {
      return this.isLayoutMobile ? [] : [this.topBasics[0]];
    },
  },
  methods: {
    ...mapActions('browse', ['getStaticPageFull']),
    ...mapActions('popup', ['setCurrentPopup']),
    openResearch() {
      this.setCurrentPopup(MODALS.RESEARCH);
    },
  },
  created() {
    this.getStaticPageFull(STATIC_PAGES.WHAT_IS)
      .then((data) => {
        this.installDynamicControls({ data });
      });
  },
};



// WEBPACK FOOTER //
// ./src/components/support/what-is-predictit/what-is-predictit.js